<div
  class="pdf-wrp flex flex-col flex-auto md:w-250 md:min-w-200 -m-6 overflow-y-auto relative"
>
  <!-- Header -->
  <div
    class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary"
  >
    <div class="text-lg font-medium">{{ origination }}</div>
    <button mat-icon-button (click)="matDialogRef.close()" [tabIndex]="-1">
      <mat-icon
        class="text-current"
        [svgIcon]="'heroicons_outline:x'"
      ></mat-icon>
    </button>
  </div>

  <div class="p-4" style="height: 650px; overflow: auto">
    <ng-container *ngFor="let app of filteredApps; let i = index">
      <div
        class="grid custom-legend-grid py-3 cursor-pointer border-b-2"
        (click)="goToStartupDetail(app)"
      >
        <div class="flex items-center">
          <div class="">{{ i + 1 }}.</div>
          <div class="ml-3 truncate">
            <span>{{
              app.projectTitle
                ? app.projectTitle
                : app.startupName
                ? app.startupName
                : app.name + " " + app.surname
            }}</span>
            <span *ngIf="app.otherOrigination" class="font-bold">
              ({{ app.otherOrigination }})
            </span>

            <span *ngIf="app.originationName" class="font-bold">
              ({{ app.originationName }})
            </span>
          </div>
        </div>
        <!--            <div class="font-medium text-right">{{dataset.numberValue | number:'1.0-0'}}</div>-->
        <!--            <div class="text-right text-secondary">{{dataset.percentageValue}}%</div>-->
      </div>
    </ng-container>
  </div>
</div>
